const Type = {
    none: undefined,
    all: 'all',
    group: 'group',
    column: 'column',
    time: 'time',
    cell: 'cell'
}

class V2ReservationSelectAreaHelper {
    constructor() {
        this.Type = Type
        this.currentType = Type.none
        this.defaultPoint = { x: undefined, y: undefined }
        this.defaultRange = {
            start: this.defaultPoint,
            end: this.defaultPoint
        }
        this.selectedRange = this.defaultRange

        this.startPoint = this.defaultPoint
        this.endPoint = this.defaultPoint
    }

    // MARK: - Setters
    setType(type) {
        this.currentType = type
    }

    setStartPoint(x, y) {
        this.startPoint = { x: x, y: y }
        this.endPoint = this.defaultPoint
    }

    setEndPoint(x, y) {
        this.endPoint = { x: x, y: y }
    }

    setSelectedRange(startX, startY, endX, endY) {
        let range = {
            start: { x: startX, y: startY },
            end: { x: endX, y: endY }
        }
        this.selectedRange = range
    }

    clearStartEndPoint() {
        this.startPoint = this.defaultPoint
        this.endPoint = this.defaultPoint
    }

    clearSelectedRange() {
        this.selectedRange = this.defaultRange
    }

    // Getters
    get isTimeSelection() {
        return this.currentType == Type.all || this.currentType == Type.time
    }

    get isColumnGroupSelection() {
        return this.currentType == Type.all || this.currentType == Type.column || this.currentType == Type.group
    }
}


export default {
    Type: Type,
    V2ReservationSelectAreaHelper: V2ReservationSelectAreaHelper
}